import { FiltersGroupModule } from './../../../widgets/filters/filters-group/filters-group.module';
import { ActivityGroupFieldModule } from './activity-group-field/activity-group-field.module';
import { ActivityCreateActivityPopUpModule } from './activity-create-activity-pop-up/activity-create-activity-pop-up.module';
import { InfoHeaderModule } from './../../../widgets/info-header/info-header.module';
import { InfoTableModule } from './../../../widgets/info-table/info-table.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxChartModule, DxDataGridModule, DxDropDownButtonModule, DxPopupModule, DxRangeSelectorModule, DxTextAreaModule, DxDateBoxModule, DxAutocompleteModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import ActivityComponent from './activity.component';
import { ActivityRoutingModule } from './activity-routing.module';
import { BookmarksControlsComponent } from 'src/app/widgets/bookmark-new/bookmarks-controls/bookmarks-controls.component';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';

@NgModule({
  declarations: [ActivityComponent],
  imports: [
		CommonModule,

		DxTableControllerDirective,

		ActivityRoutingModule,

		FiltersGroupModule,
		BookmarkNewComponent,
		BookmarksControlsComponent,
		HelpButtonComponent,

		DxChartModule,
		DxDropDownButtonModule,
		DxTextAreaModule,
		DxRangeSelectorModule,
		DxDataGridModule,
		DevEpressCommonModule,
		DxButtonModule,
		DxPopupModule,
		DxDateBoxModule,
		DxAutocompleteModule,
		InfoHeaderModule,
		InfoTableModule,
		ActivityCreateActivityPopUpModule,
		ActivityGroupFieldModule,
  ]
})
export class ActivityModule { }
